import AuthService from "./auth";

export default class EndPoints {
  public static auth = new AuthService();
}
